import React from 'react';
import { useTranslation } from 'react-i18next';

import YeulsButton from '../../../yeuls-button';

const RequestPageLayout = (props) => {
  const {
    tTitle,
    tSubtitle,
    tSubmitLabel,
    onSubmit,
    submitting,
    submitClassName,
    children,
  } = props;
  const { t } = useTranslation();

  return (
    <div className="request-page-container">
      <div className="request-page-header">
        <h1 className="request-page-title">{t(tTitle)}</h1>
        <p className="request-page-subtitle">{t(tSubtitle)}</p>
      </div>

      <div className="request-page-body">{children}</div>

      {onSubmit && tSubmitLabel && (
        <div className="request-page-actions">
          <YeulsButton
            className={`request-submit-button ${submitClassName || ''}`}
            onClick={onSubmit}
            disabled={submitting}
            loading={submitting}
          >
            {t(tSubmitLabel)}
          </YeulsButton>
        </div>
      )}
    </div>
  );
};

export default RequestPageLayout;
